// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterTwoToneSvg from "@fishx/icons-svg/es/asn/FilterTwoTone";
import FishxIcon from '../components/FishxIcon';

var FilterTwoTone = function FilterTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterTwoToneSvg
  }));
};

FilterTwoTone.displayName = 'FilterTwoTone';
export default React.forwardRef(FilterTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilterTwoTone.js
// module id = 2771
// module chunks = 0